<template>
    <!-- 地图区域 -->
    <baidu-map @ready="initMap" :zoom="zoom" :center="center" style="height: 60vh; width: 100%" :scroll-wheel-zoom="true" :double-click-zoom="false">
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
    </baidu-map>
</template>
<script>
export default {
    name: 'MapFence',
    props: {
        regionObj: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            map: null,
            BMap: null,
            zoom: 5,
            center: { lng: 109.45744048529967, lat: 36.49771311230842 }
        };
    },
    watch: {
        regionObj(val) {
            if (val) {
                this.drawPolygon(val.label);
            }
        }
    },
    methods: {
        initMap({ BMap, map }) {
            this.map = map;
            this.BMap = BMap;
            this.regionObj.label && this.drawPolygon(this.regionObj.label);
        },
        getZoom() {
            console.log(this.map.getZoom());
        },
        // 绘制行政区划轮廓
        drawPolygon(regionName) {
            this.map && this.map.clearOverlays();
            let that = this;
            let bdary = new BMap.Boundary();
            bdary.get(regionName, function (rs) {
                //轮廓的总数 —— 有的区由多个封闭区域组成
                let count = rs.boundaries.length;
                if (!count) {
                    console.log('未能获取到当前输入的行政区域');
                    return;
                }

                // 获取中心点
                let bounds = new BMap.Bounds();
                let boundaryPoints = rs.boundaries;
                let tmpPoints = [];
                let allPoints = [];
                // boundaryPoints.forEach((pointStr) => {
                //     let coords = pointStr.split(',');
                //     bounds.extend(new BMap.Point(parseFloat(coords[0]), parseFloat(coords[1])));
                //     tmpPoints.push(new BMap.Point(parseFloat(coords[0]), parseFloat(coords[1])));
                // });

                // 遍历所有边界区域（包括飞地）
                boundaryPoints.forEach((boundaryStr, index) => {
                    // 解析当前区域的边界点
                    const points = [];
                    boundaryStr.split(';').forEach((pointStr) => {
                        const coords = pointStr.split(',');
                        points.push(new BMap.Point(parseFloat(coords[0]), parseFloat(coords[1])));
                        tmpPoints.push(new BMap.Point(parseFloat(coords[0]), parseFloat(coords[1])));
                    });

                    // 添加到总点集
                    allPoints.push(...points);
                });

                // 获取Bounds的中心点（等价于几何中心）
                that.center = bounds.getCenter();

                // 使用 setViewport 自动计算最佳视野
                that.map.setViewport(tmpPoints);
                const currentZoom = that.map.getZoom();
                that.zoom = currentZoom;
                // console.log(`当前城市: ${regionName}, 自动缩放级别: ${currentZoom}`);

                // 绘制区域
                for (let i = 0; i < count; i++) {
                    //创建多边形覆盖物
                    let ply = new BMap.Polygon(rs.boundaries[i], {
                        strokeWeight: 3,
                        strokeColor: 'red',
                        fillColor: '#3388ff',
                        fillOpacity: 0.3,
                        strokeStyle: 'dashed'
                    });
                    // 给覆盖物添加点击事件
                    ply.addEventListener('click', function () {
                        // console.log('当前区域：' + regionName);
                        // 改变自己的透明度
                        this.setFillOpacity(1);
                    });
                    //添加覆盖物
                    that.map.addOverlay(ply);
                }
            });
        }
    }
};
</script>